export default {
  'PerformerBanner.FindaMusician': {
    en: 'Find a Musician',
    fr: 'Trouver un musicien',
  },
};
